import { render, staticRenderFns } from "./HomeService.vue?vue&type=template&id=656a1200&scoped=true"
import script from "./HomeService.vue?vue&type=script&lang=js"
export * from "./HomeService.vue?vue&type=script&lang=js"
import style0 from "./HomeService.vue?vue&type=style&index=0&id=656a1200&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a1200",
  null
  
)

export default component.exports